import {Line} from 'react-chartjs-2';
import {CategoryScale, Chart as ChartJS, Legend, LinearScale, LineElement, PointElement, Title, Tooltip,} from 'chart.js';

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend
);


const options = {
	responsive: true,
	plugins: {
		legend: {
			position: 'bottom' as const,
		},
	},
};

export interface LChartSeries {
	label: string;
	color: string;
	values: number[]
}

export interface LChart {
	xAxisData: any[]
	seriesData: LChartSeries[]
}

export interface LineChartProps {
	data: LChart | undefined;
}

export function LineChart({data}: LineChartProps) {

	const _data = data ? {
		labels: data.xAxisData,
		datasets: data.seriesData.map((series) => {

			return {
				label: series.label,
				data: series.values,
				borderColor: series.color,
				backgroundColor: series.color,
			}
		}),
	} : undefined;

	return (
		<>
			{_data && (
				<Line height={75} options={options} data={_data}/>
			)}
		</>
	);
}
